export const updateFocusedCell = (moveCell, columns, rows, focusedCell, onFocusedCell, disabledCellChecker) => {
    let newCell = Object.assign({}, focusedCell.coords);
    let isActive = moveCell.tabStoping;
    if (moveCell.x === 0 && moveCell.y === 0) {
        onFocusedCell({ x: newCell.x, y: newCell.y, active: isActive });
        return;
    }
    if (moveCell.uncoded) {
        onFocusedCell({ x: newCell.x - 1, y: newCell.y, active: true, ignoreLeaveRow: true });
        return;
    }
    newCell.x += moveCell.x;
    newCell.y += moveCell.y;
    if (newCell.y < 0)
        newCell.y = 0;
    if (newCell.y >= columns.length)
        newCell.y = columns.length - 1;
    const rowCount = rows.length;
    if (newCell.x < 0)
        newCell.x = 0;
    if (newCell.x >= rowCount)
        newCell.x = rowCount - 1;
    while (checkTabStop(rows[newCell.x], columns[newCell.y], disabledCellChecker, moveCell.stopAtColId) !== true && moveCell.tabStoping === true) {
        while (checkTabStop(rows[newCell.x], columns[newCell.y], disabledCellChecker, moveCell.stopAtColId) !== true) {
            if (moveCell.stopAtColId)
                newCell.y += 1;
            else
                newCell.y += (moveCell.y !== 0 ? moveCell.y : 1);
            if (newCell.y < 0 || newCell.x < 0 || (newCell.y >= columns.length && newCell.x >= rowCount))
                return;
            if (newCell.y >= columns.length) {
                newCell.y = 0;
                break;
            }
            if (newCell.y <= 0) {
                newCell.y = columns.length - 1;
                break;
            }
        }
        if (!(newCell.y === 0 && moveCell.tabStoping === true)) {
            if (checkTabStop(rows[newCell.x], columns[newCell.y], disabledCellChecker) === true || newCell.x >= rowCount)
                break;
        }
        newCell.x += (moveCell.x !== 0 ? moveCell.x : moveCell.y);
    }
    onFocusedCell({ x: newCell.x, y: newCell.y, active: isActive });
};

const checkTabStop = (row, column, disabledCellChecker, stopAtColId) => {
    if (stopAtColId) {
        if (column.id === stopAtColId)
            return true;
    } else {
        if (column.tabStop === true)
            return true;
        else if (disabledCellChecker && column.tabStop === 'enable')
            return !disabledCellChecker(row, column.id)
    }
    return false;
}

let _resizingObject = {
    originalMouseX: 0,
    originalWidth: 0,
    originalRelatedCellwidth: 0,
    resizingCell: null,
    resizingColumn: null,
    relatedCell: null,
    relatedColumnId: null,
    primaryColumnWidthValues: [],
    columnMinWidthValues: [],
    columnMaxWidthValues: [],
    updateColumnWidthList: null,
    onColumnResize: null
}
export const startColumnResize = (e, column, columns, columnWidthList, primaryColumnWidthValues, columnMinWidthValues, columnMaxWidthValues, updateColumnWidthList, onColumnResize) => {
    e.preventDefault();
    _resizingObject.originalMouseX = e.pageX;
    _resizingObject.resizingCell = e.currentTarget.offsetParent;
    _resizingObject.resizingColumn = column;
    _resizingObject.originalWidth = _resizingObject.resizingCell.offsetWidth;
    _resizingObject.primaryColumnWidthValues = primaryColumnWidthValues;
    _resizingObject.columnMinWidthValues = columnMinWidthValues;
    _resizingObject.columnMaxWidthValues = columnMaxWidthValues;
    _resizingObject.updateColumnWidthList = updateColumnWidthList;
    _resizingObject.onColumnResize = onColumnResize;

    const flexColumn = Object.keys(columnWidthList).find(key => {
        return primaryColumnWidthValues[key] === undefined;
    });
    const cellIndex = _resizingObject.resizingCell.dataset.index * 1;
    _resizingObject.relatedColumnId = columns[cellIndex + 1].id;
    if (cellIndex < columns.indexOf(flexColumn))
        _resizingObject.relatedColumnId = flexColumn;
    _resizingObject.relatedCell = document.querySelectorAll(`col[data-resize-column-id='${_resizingObject.relatedColumnId}']`)[0];
    _resizingObject.originalRelatedCellwidth = parseInt(_resizingObject.relatedCell.style.width, 10);
    document.addEventListener('mousemove', processColumnResize);
    document.addEventListener('mouseup', stopColumnResize);
}

export const processColumnResize = (e) => {
    if (_resizingObject.resizingColumn) {
        const diff = e.pageX - _resizingObject.originalMouseX;
        let newColumnWidth = _resizingObject.originalWidth + diff;
        if (newColumnWidth % 5 === 0) {
            const minColumnWidth = _resizingObject.columnMinWidthValues[_resizingObject.resizingColumn.id] || _resizingObject.primaryColumnWidthValues[_resizingObject.resizingColumn.id];
            const maxColumnWidth = _resizingObject.columnMaxWidthValues[_resizingObject.resizingColumn.id] || _resizingObject.primaryColumnWidthValues[_resizingObject.resizingColumn.id];
            const minRelatedColumnWidth = _resizingObject.columnMinWidthValues[_resizingObject.relatedColumnId] || _resizingObject.primaryColumnWidthValues[_resizingObject.relatedColumnId];
            const maxRelatedColumnWidth = _resizingObject.columnMaxWidthValues[_resizingObject.relatedColumnId] || _resizingObject.primaryColumnWidthValues[_resizingObject.relatedColumnId];

            if (minColumnWidth > newColumnWidth) {
                newColumnWidth = minColumnWidth;
            }
            if (newColumnWidth > maxColumnWidth) {
                newColumnWidth = maxColumnWidth;
            }
            let relatedColumnWidth = _resizingObject.originalRelatedCellwidth - (newColumnWidth - _resizingObject.originalWidth);
            if (minRelatedColumnWidth > relatedColumnWidth) {
                relatedColumnWidth = minRelatedColumnWidth;
                newColumnWidth = _resizingObject.originalWidth + (_resizingObject.originalRelatedCellwidth - minRelatedColumnWidth);
            }
            if (maxRelatedColumnWidth < relatedColumnWidth) {
                relatedColumnWidth = maxRelatedColumnWidth;
                newColumnWidth = _resizingObject.originalWidth - (maxRelatedColumnWidth - _resizingObject.originalRelatedCellwidth);
            }

            const columnsToResize = document.querySelectorAll(`[data-resize-column-id='${_resizingObject.resizingColumn.id}']`);
            columnsToResize.forEach((column) => {
                column.style.width = `${newColumnWidth}px`;
                if (column.tagName == 'DIV')
                    column.style.borderRight = "1px solid #e0e0e0";
            });
            const relatedColHeaderToResize = document.querySelectorAll(`col[data-resize-column-id='${_resizingObject.relatedColumnId}']`)[0];
            const relatedColumnsToResize = document.querySelectorAll(`div[data-resize-column-id='${_resizingObject.relatedColumnId}']`);
            var diffColandColumn = parseInt(relatedColHeaderToResize.style.width, 10) - parseInt(relatedColumnsToResize[0].style.width, 10);
            relatedColumnsToResize.forEach((column) => {
                column.style.width = `${relatedColumnWidth - diffColandColumn}px`;
            });
            relatedColHeaderToResize.style.width = `${relatedColumnWidth}px`;
        }
    }
}

export const stopColumnResize = () => {
    document.removeEventListener('mousemove', processColumnResize);
    if (_resizingObject.resizingColumn) {
        let columnsToRemoveBorder = document.querySelectorAll(`div[data-resize-column-id='${_resizingObject.resizingColumn.id}']`);
        columnsToRemoveBorder.forEach((column) => { column.style.borderRight = null; });
        let ColumnWidthList = {};
        const columnElements = document.getElementById('header-row').childNodes;
        columnElements.forEach((column, idx) => {
            ColumnWidthList[column.getAttribute('data-column-id')] = column.offsetWidth;
        });
        _resizingObject.updateColumnWidthList(ColumnWidthList);
        _resizingObject.resizingColumn = null;
        if (_resizingObject.onColumnResize) {
            _resizingObject.onColumnResize(ColumnWidthList);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/DataTable/helpers.js